import { Badge } from "@chakra-ui/react";

const BadgeUserStatus = ({ status }) => {
    let color = "gray"
    let text = "ไม่ระบุ"

    if (status === "ACTIVE") {
        color = "green"
        text = "ใช้งานปกติ (Active)"
    } else if (status === "INACTIVE") {
        color = "red"
        text = "ระงับการใช้งาน (Inactive)"
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeUserStatus